import { Action, Dispatch } from "redux";
import { BaseMedia, MediaFields } from "typings/media";
import API from "../../services/api";
import { statusAdd } from "../ui/action";
import { createStatusMessage } from "../ui/StatusMessage";
export interface LoadMediaSuccessAction extends Action
{
    type: "LOAD_MEDIA_SUCCES";
    media: BaseMedia[];
}

export interface NewMediaSuccessAction extends Action
{
    type: "NEW_MEDIA_SUCCESS";
    media: BaseMedia[];
}

export interface DeleteMediaSuccessAction extends Action
{
    type: "DELETE_MEDIA_SUCCESS";
    id: string;
}

export interface MediaUpdateSuccessAction extends Action
{
    type: "UPDATE_MEDIA_SUCCESS";
    id: string;
    data: MediaFields;
}

export const loadMediaSuccess = (media: BaseMedia[]): LoadMediaSuccessAction => ({
    type: "LOAD_MEDIA_SUCCES",
    media
});

export const newMediaSuccess = (media: BaseMedia[]): NewMediaSuccessAction => ({
    type: "NEW_MEDIA_SUCCESS",
    media
});

export const deleteMediaSuccess = (id: string): DeleteMediaSuccessAction => ({
    type: "DELETE_MEDIA_SUCCESS",
    id
});

export const updateMediaSuccess = (id: string, data: MediaFields): MediaUpdateSuccessAction => ({
    type: "UPDATE_MEDIA_SUCCESS",
    id,
    data
});

export const createFolder = (folderName: string, navigate?: (parentId: string) => void, parentId?: string) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const media = await API.media.createFolder(folderName, parentId);
        const successAction: NewMediaSuccessAction = {type: "NEW_MEDIA_SUCCESS", media:[media] };
        dispatch(successAction);
        if (navigate)
        {
            navigate(media.id);
        }
    }
    catch (e)
    {
        const status = createStatusMessage("Creating folder failed", "error", "media");
        dispatch(statusAdd(status));
       
    }
};

export const uploadLink = (url: string, parentId: string) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const media = await API.media.uploadYoutube(url, parentId);
        const successAction: NewMediaSuccessAction = {type: "NEW_MEDIA_SUCCESS", media: [ media.content ] };
        dispatch(successAction);
        const statusFinished = createStatusMessage("Upload finished", "success", "media");
        dispatch(statusAdd(statusFinished));
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Uploading link failed", "error", "media");
        dispatch(statusAdd(statusFinished));
    }
};

export const uploadFiles = (files: File[], parentId: string) => async (dispatch: Dispatch<Action>) =>
{
    const status = createStatusMessage("Uploading files", "info", "media");
    dispatch(statusAdd(status));
    try
    {
        const {assets, invalidFiles } = await API.media.uploadFiles(files, parentId);
        const successAction: NewMediaSuccessAction = {type: "NEW_MEDIA_SUCCESS", media: assets };
        dispatch(successAction);
        const statusFinished = createStatusMessage("Upload finished", "success", "media", status.id);
        dispatch(statusAdd(statusFinished));
        if (invalidFiles.length > 0)
        {
            invalidFiles.forEach(file => 
            {
                const statusFinished = createStatusMessage( `Failed uploading '${file}'`, "error", "media");
                dispatch(statusAdd(statusFinished));
            });
        }
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Uploading files failed", "error", "media", status.id);
        dispatch(statusAdd(statusFinished));
       
    }
};

export const loadMedia = (id?: string) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const media = await API.media.getMedia(id);
        const successAction: LoadMediaSuccessAction = {type: "LOAD_MEDIA_SUCCES", media };
        dispatch(successAction);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Loading media failed", "error", "media");
        dispatch(statusAdd(statusFinished));
       
    }
};

export const loadMultipleMedia = (ids: string[]) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const media = await API.media.loadMultipleMedia(ids);
        const successAction: LoadMediaSuccessAction = {type: "LOAD_MEDIA_SUCCES", media };
        dispatch(successAction);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Loading media failed", "error", "media");
        dispatch(statusAdd(statusFinished));
       
    }
};

export const updateMedia = (mediaId: string, update: { [key: string]: string }) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        await API.media.updateMedia(mediaId, update);
        const data: MediaFields = {};
        Object.keys(update).forEach(key => data[key] = { value: update[key] });
        const action: MediaUpdateSuccessAction ={ type: "UPDATE_MEDIA_SUCCESS", id: mediaId, data  };
        dispatch(action);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Media update failed", "error", "media");
        dispatch(statusAdd(statusFinished));
       
    }
};

export const deleteMedia = (id: string) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        await API.media.delete(id);
        const successAction: DeleteMediaSuccessAction = {type: "DELETE_MEDIA_SUCCESS", id };
        dispatch(successAction);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Delete failed", "error", "media");
        dispatch(statusAdd(statusFinished));
       
    }
};

export type MediaActions = 
    LoadMediaSuccessAction
    | NewMediaSuccessAction
    | DeleteMediaSuccessAction
    | MediaUpdateSuccessAction
;


// WEBPACK FOOTER //
// ./src/state/media/action.ts